"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getColumnClassName(id, i) {
  return "column-" + id + "-" + i;
}

function paginate(_ref) {
  var page = _ref.page,
      perPage = _ref.perPage;

  return function () {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    // adapt to zero indexed logic
    var p = page - 1 || 0;

    var amountOfPages = Math.ceil(rows.length / perPage);
    var startPage = p < amountOfPages ? p : 0;

    return {
      amount: amountOfPages,
      rows: rows.slice(startPage * perPage, startPage * perPage + perPage),
      page: startPage
    };
  };
}

exports.getColumnClassName = getColumnClassName;
exports.paginate = paginate;


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTable/TableUtilities/Utilities.js
// module id = 1614
// module chunks = 0